import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { GetBill$Params } from 'src/api/generated/fn/order-v-2/get-bill';
import { BillDetailsDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Bills/bill-details-dto';
import { MenuCurrencyDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Menu/menu-currency-dto';
import { OrderDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/OrderV2/order-dto';
import { OrderV2Service } from 'src/api/generated/services';
import { BillStatuses } from 'src/app/pos-panel/enums/bill-statuses.enum';
import { CurrencyService } from 'src/app/pos-panel/services/currency-helper/currency.service';
import { CurrentVenueHelperService } from 'src/app/share-modul/services/current-venue-helper/current-venue.helper.service';

@Component({
  selector: 'app-bill-details',
  templateUrl: './bill-details.component.html',
  styleUrls: ['./bill-details.component.scss']
})
export class BillDetailsComponent implements OnInit, OnDestroy {
  
  bill: BillDetailsDto;
  billId: string;
  venueId: string;
  orders: Array<OrderDto> = new Array<OrderDto>();
  selectedOrder: OrderDto;
  totalAmount: number = 0;
  amountPaid: number = 0;
  changeDue: number = 0;
  billTables: string;
  venueIdUpdateSubscription: Subscription;
  currency: MenuCurrencyDto;
  BillStatus = BillStatuses;

  constructor(private route: ActivatedRoute,
              public router: Router,
              public currentVenueHelper: CurrentVenueHelperService,
              public currencyService: CurrencyService,
              public orderService: OrderV2Service) {

      this.route.params.subscribe(params => {
      this.venueId = params['venue-id'];
      this.currentVenueHelper.updateCurrentVenueIdDropdown(params['venue-id']);
      this.billId = params['bill-id'];  
      const getParams: GetBill$Params = { billId: this.billId };
      this.orderService.getBill(getParams).subscribe(response => {
        this.bill = response;
        this.billTables =  this.bill.tables ? this.bill.tables?.map(table => table.name).join(", ") : "";
        this.amountPaid = 0;
        if(this.bill.paidWithCard){
          this.amountPaid += this.bill.paidWithCard;
        }
        if(this.bill.paidWithCash){
          this.amountPaid += this.bill.paidWithCash;
        } 
      })
  });  
  this.currencyService.currencyObservable().subscribe(currency => this.currency = currency);
}

  ngOnInit(): void {
  }

  goToOrder(order: any){
    this.router.navigate([this.venueId, 'turnover', 'orders', order.id]);
  }
  goToTurnoverRecords(){
    this.router.navigate([this.venueId, 'turnover'], { queryParams: { activeIndex: 1 }});
  }

  public ngOnDestroy(): void {
    if (this.venueIdUpdateSubscription) {
      this.venueIdUpdateSubscription.unsubscribe();
    }
  }

}
